import useIsMobile from 'utils/hooks/useIsMobile'
import {DataGridPro, GridRowId, useGridApiRef} from '@mui/x-data-grid-pro'
// import {serverLocalName} from 'GLOBAL/envVariables'
// import CorrectModal from 'pages/common/CorrectModal'
import {envBackHost, envImagePath, serverLocalName} from 'GLOBAL/envVariables'
import {axiosWithAuth} from 'helper/axiosWithAuth'
import fileDownload from 'js-file-download'
import CorrectModal from 'pages/common/CorrectModal'
import CustomerDetailInfoMdal from 'pages/common/CustomerDetailInfoMdal'
import CustomerTargetImageListModal from 'pages/common/CustomerTargetImageListModal'
import DeviceDetailInfoModal from 'pages/common/DeviceDetailInfoModal'
import ExcelDownLoadModal from 'pages/common/ExcelDownloadModal'
import PhotoModal from 'pages/common/PhotoModal'
import {
  customerInfoBoardVersionColumns,
  customerInfoGyeryongBoardVersionColumns,
} from 'pages/customer/dataConfig/declearColumns'
import {
  customerInfoExtendFilter,
  customerInfoNewFilter,
} from 'pages/customer/dataConfig/declearFilters'
import {customerInfoBoardVersionGroup} from 'pages/customer/dataConfig/declearGroupingModel'
import {customerInfoBoardVersionRows} from 'pages/customer/dataConfig/declearRows'
import {useEffect, useMemo, useState} from 'react'
import {useSelector} from 'react-redux'
import {useLocation} from 'react-router-dom'
import {toast, ToastContainer} from 'react-toastify'
import {
  deleteCustomerList,
  getAsCauseList,
  getCustomerList,
  getCustomerNewList,
} from 'utils/apiCalling/api'
import {usePhotoModalOffice} from 'utils/config/photoConfig'
import {useServerCycleSetting} from 'utils/config/serverCycleConfig'
import {outerInstallShowHandler} from 'utils/const/globalController'
import {
  confirmPhotoAlert,
  noPhotoAlert,
  resultAlert,
  warningPhotoAlert,
} from 'utils/CustomAlert/Alert'
import CustomPagination from 'utils/designSytem/CustomPagination'
import useSelectionRemap from 'utils/hooks/useSelectionRemap'
import MeterariumPageLayout from 'utils/designSytem/MeterariumPageLayout'
import {
  correctModalClose,
  customerDetailModalClose,
  customerDetailModalOpen,
  deviceDetailModalClose,
  deviceDetailModalOpen,
  imageDetailModalClose,
  imageDetailModalOpen,
  onRowsSelectionHandler,
  photoModalClose,
  photoModalOpen,
  scrollTop,
} from 'utils/func/justUtils'
import {toolTipText} from 'utils/toolTips/toolTipText'
import {customerInfoSearchOption} from '../dataConfig/declearSearchOptions'
import AsBatchOffcanvas from '../modules/asBatchOffcanvas'
import CustomerInfoMobileCard from './CustomerInfoMobileCard'

const CustomerInfo = (props: any) => {
  /*********************************************************************
   * 1. Init Libs
   *********************************************************************/
  const location = useLocation()
  const pageState = location?.state
  const isMobile = useIsMobile()
  const userInfo = useSelector((state: any) => state.userInfo?.userInfo)
  const officeInfo = useSelector((state: any) => state?.officeInfo)
  const cooperInfo = useSelector((state: any) => state?.cooperInfo)
  /* 통신주기 필터는 사업소별로 노출 화면과 선택지가 다르다 (/dev/server-cycle-config 에서 관리) */
  const serverCycle = useServerCycleSetting(officeInfo?.value)
  /* 행 클릭 시 사진 모달과 수용가 상세 중 무엇을 열지 (/dev/photo-config 에서 관리).
     컬럼 정의는 isPhotoModalOffice 를 직접 읽으므로, 설정이 도착하면 이 훅이
     화면을 다시 그려 컬럼 판정까지 함께 갱신한다. */
  const usePhotoModal = usePhotoModalOffice(officeInfo?.value)
  const searchOptionList = useMemo(() => {
    const showServerCycle = serverCycle.pages.includes('info')
    return customerInfoSearchOption
      .filter((option) => option.id !== 'serverCycle' || showServerCycle)
      .map((option) =>
        option.id === 'serverCycle' ? {...option, options: serverCycle.options} : option
      )
  }, [serverCycle])
  /*********************************************************************
   * 2. State settings
   *********************************************************************/
  const [asReasonData, setAsReasonData] = useState<any>('')
  const [checkData, setCheckData] = useState<any>([])
  const [loading, setLoading] = useState(false)
  const [customerDetailData, setCustomerDetailData] = useState<any>(null)
  const [deviceDetailData, setDeviceDetailData] = useState<any>()
  const [causeList, setCauseList] = useState<any>(null)
  const [customerInfoList, setCustomerInfoList] = useState<any>(null)
  const [selectionModel, setSelectionModel] = useState<GridRowId[]>([])
  const [totalCount, setTotalCount] = useState<any>(null)
  const [filter, setFilter] = useState<any>(customerInfoExtendFilter(pageState))
  const [imageDetailOpen, setImageDetailOpen] = useState<boolean>(false)
  const [deviceDetailOpen, setDeviceDetailOpen] = useState<boolean>(false)
  const [customerDetailOpen, setCustomerDetailOpen] = useState<boolean>(false)
  const [openCorrectModal, setOpenCorrectModal] = useState<boolean>(false)
  const [accordionOpen, setAccordionOpen] = useState<boolean>(false)
  const [downloadOpen, setDownloadOpen] = useState<boolean>(false)
  const [photoData, setPhotoData] = useState<any>({})
  const [targetRowId, setTargetRowId] = useState<any>(0)
  const [photoModal, setPhotoModal] = useState<boolean>(false)
  const [rows, setRows] = useState<any[]>([])

  useSelectionRemap({rows, checkData, selectionModel, setCheckData, setSelectionModel})
  //reset용
  const [shouldCallApi, setShouldCallApi] = useState<boolean>(false)
  const [diameterFilter, setDiameterFilter] = useState<any>([])
  /*********************************************************************
   * 3. Handlers
   *********************************************************************/
  const getCustomerInfo = async () => {
    const handleResponse = async (res: any, count: any) => {
      const rows = customerInfoBoardVersionRows(res).map((row: any) => ({
        ...row,
        imageWidth: null,
        imageHeight: null,
      }))

      setCustomerInfoList(res)
      setRows(rows)
      setTotalCount(count)

      rows.forEach((row: any) => {
        if (row.filePath) {
          const img = new Image()
          img.src = envImagePath + row.filePath
          img.onload = () => {
            setRows((prev) =>
              prev.map((r) =>
                r.id === row.id && !r.imageWidth
                  ? {...r, imageWidth: img.width, imageHeight: img.height}
                  : r
              )
            )
          }

          img.onerror = () => {
            setRows((prev) =>
              prev.map((r) =>
                r.id === row.id && !r.imageWidth ? {...r, imageWidth: null, imageHeight: null} : r
              )
            )
          }
        }
      })
    }

    if (filter?.searchDataField?.split(',').filter(Boolean).length > 0) {
      //필터키로 자동 구분
      const filterKeys = [
        'deviceStatus',
        'efosStatus',
        'freezeWarningType',
        'recognizedType',
        'deviceType',
        'batteryStatus',
        'signalStrength',
        'temperature',
        'customerStatus',
        'isRevised',
        'processStatus',
        'serverCycle',
        'diameters',
        'startDate',
        'endDate',
      ]

      let selectedFilter: Record<string, any> = {
        ...customerInfoNewFilter(pageState),
        ...filterKeys.reduce((acc, key) => {
          acc[key] = filter?.[key]
          return acc
        }, {} as Record<string, any>),
        rowPerPage: filter?.rowPerPage, //
        page: filter?.page, //
      }
      const dataArr = (filter.searchData ?? '').split('&&')
      const fields = (filter.searchDataField ?? '').split(',').map((f: any) => f.trim())
      fields.forEach((field: any, idx: any) => {
        if (dataArr[idx]) selectedFilter[field] = dataArr[idx]
      })

      await getCustomerNewList(
        officeInfo,
        cooperInfo,
        selectedFilter,
        async (res: any, count: any) => {
          handleResponse(res, count)
        },
        (error: any) => {},
        () => {
          setLoading(false)
        }
      )
    } else {
      await getCustomerList(
        officeInfo,
        cooperInfo,
        filter,
        async (res: any, count: any) => {
          handleResponse(res, count)
        },
        (error: any) => {},
        () => {
          setLoading(false)
        }
      )
    }
  }

  const deleteCustomerListCall = async () => {
    await deleteCustomerList(checkData, {
      success: async (res) => {
        await getCustomerInfo()
        setCheckData([])
        setSelectionModel([])
      },
      fail: (err) => {
        console.log(err)
      },
      loading: (bool: boolean) => {
        setLoading(bool)
      },
    })
  }
  const apiRef = useGridApiRef()
  const getphotoDownload = async (types: any) => {
    const customerNumberMap = checkData
      .filter((item: any) => item.existsInstallPhoto === true)
      .map((item: any) => item.customerNumber)
    const customerNumberList = customerNumberMap.join(',')
    const status = 'INFO'

    const photoAlertTextHandler = (type: any, length: any) => {
      switch (type) {
        case 'excel':
          if (length > 50) {
            return '50개 이상 받으실 경우 Zip파일로 제공되며,<br/> 시간이 오래 걸릴 수 있습니다.'
          }
          return `선택한 수용가 중 사진첩이 있는 ${length}건이 엑셀 파일로 제공되며,<br/> 시간이 오래 걸릴 수 있습니다.`
        case 'pdf':
          return `선택한 수용가 중 사진첩이 있는 ${length}건이 PDF 파일로 제공되며,<br/> 시간이 오래 걸릴 수 있습니다.`
        default:
          return ''
      }
    }

    const isZip = customerNumberMap.length > 50 ? true : false

    const text = photoAlertTextHandler(types, customerNumberMap.length)

    if (customerNumberMap.length === 0) {
      await noPhotoAlert()
      return false
    }

    if (customerNumberMap.length > 100) {
      await warningPhotoAlert()
      return false
    }

    switch (types) {
      case 'excel':
        if (await confirmPhotoAlert(text)) {
          await toast
            .promise(
              axiosWithAuth()
                .get(`${envBackHost}/customer/excel/photo/${officeInfo?.value}`, {
                  params: {customerNumbers: customerNumberList, status: status},
                  responseType: 'blob',
                })
                .then(async (res) => {
                  await resultAlert({resultCode: 0})
                  fileDownload(res.data, `${officeInfo?.label}_사진첩.${isZip ? 'zip' : 'xlsx'}`)
                })
                .catch(async (e) => {
                  await resultAlert({resultCode: 400})
                }),
              {
                pending: '다운로드 중입니다.',
              },
              {
                position: 'top-center',
                autoClose: 1000,
                className: 'fs-3  fw-bold',
                style: {width: '400px'},
              }
            )
            .catch(async (e) => {
              console.log(e)
              await resultAlert({resultCode: 400})
            })
        }
        break
      case 'pdf':
        if (await confirmPhotoAlert(text)) {
          await toast
            .promise(
              axiosWithAuth()
                .get(`${envBackHost}/customer/pdf/photo/${officeInfo?.value}`, {
                  params: {customerNumbers: customerNumberList, status: status},
                  responseType: 'blob',
                })
                .then(async (res) => {
                  await resultAlert({resultCode: 0})
                  fileDownload(res.data, `${officeInfo?.label}_사진첩.pdf`)
                })
                .catch(async (e) => {
                  await resultAlert({resultCode: 400})
                }),
              {
                pending: '다운로드 중입니다.',
              },
              {
                position: 'top-center',
                autoClose: 1000,
                className: 'fs-3  fw-bold',
                style: {width: '400px'},
              }
            )
            .catch(async (e) => {
              console.log(e)
              await resultAlert({resultCode: 400})
            })
        }
        break
      default:
        return null
    }
  }

  const openImageDetailModal = () => imageDetailModalOpen(setImageDetailOpen)
  const openDeviceDetailModal = () => deviceDetailModalOpen(setDeviceDetailOpen)
  const openCustomerDetailModal = () => customerDetailModalOpen(setCustomerDetailOpen)
  const closeImageDetailModal = () => imageDetailModalClose(setImageDetailOpen)
  const closeDeviceDetailModal = () => deviceDetailModalClose(setDeviceDetailOpen)
  const closeCustomerDetailModal = () => customerDetailModalClose(setCustomerDetailOpen)
  const closeCorrectModal = () => correctModalClose(setOpenCorrectModal)
  const closePhotoModal = () => photoModalClose(setPhotoModal)
  const openPhotoModal = () => photoModalOpen(setPhotoModal)

  const columnsHandler = (serverName: any) => {
    switch (serverName) {
      case 'gyeryong':
      case 'mokpo':
      case 'uiwang':
      case 'prod':
      case 'dev':
        return customerInfoGyeryongBoardVersionColumns(
          openImageDetailModal,
          openDeviceDetailModal,
          openCustomerDetailModal,
          setCustomerDetailData,
          setDeviceDetailData,
          userInfo,
          getCustomerInfo,
          cooperInfo,
          officeInfo,
          openPhotoModal,
          setPhotoData,
          setTargetRowId
        )

      default:
        return customerInfoBoardVersionColumns(
          openImageDetailModal,
          openDeviceDetailModal,
          openCustomerDetailModal,
          setCustomerDetailData,
          setDeviceDetailData,
          userInfo,
          getCustomerInfo,
          cooperInfo,
          officeInfo,
          openPhotoModal,
          setPhotoData,
          setTargetRowId
        )
    }
  }

  const columns: any = columnsHandler(serverLocalName)
  const columnGroupingModel = customerInfoBoardVersionGroup

  const resetHandler = () => {
    setFilter(customerInfoExtendFilter(pageState))
    setShouldCallApi(true)
  }

  const searchHandler = () => {
    setFilter((prev: any) => ({...prev, page: 1}))
    setShouldCallApi(true)
  }

  const getOfficeDiameter = async () => {
    const res = await axiosWithAuth().get(`${envBackHost}/${officeInfo.value}/mmd`)

    if (res.data.res) {
      const result = res.data.res.map((value: any) => ({
        value,
        name: `${value}mm`,
      }))

      setDiameterFilter(result)
    }
  }

  const getRowHeightOnDataGrid = (params: any) => {
    const {imageHeight} = params?.model || {}
    // 매핑 테이블
    const heightMap: Record<number, number> = {
      480: 280,
      240: 260,
      144: 180,
    }

    if (imageHeight && heightMap[imageHeight]) {
      return heightMap[imageHeight]
    }
    // 기본값
    return 180
  }
  /*********************************************************************
   * 4. useEffect
   *********************************************************************/
  useEffect(() => {
    if (shouldCallApi) {
      getCustomerInfo()
      getOfficeDiameter()
      setShouldCallApi(false)
    }
  }, [filter, shouldCallApi])

  /* A/S 원인 코드는 바뀌지 않으므로 최초 1회만 조회한다 */
  useEffect(() => {
    getAsCauseList(setCauseList)
  }, [])

  useEffect(() => {
    scrollTop()
    getCustomerInfo()
    getOfficeDiameter()
  }, [
    filter?.efosStatus,
    filter?.deviceStatus,
    filter?.deviceType,
    filter?.batteryStatus,
    filter?.freezeWarningType,
    filter?.signalStrength,
    filter?.temperature,
    filter?.isRevised,
    filter?.processStatus,
    filter.rowPerPage,
    filter.page,
    filter?.recognizedType,
    filter?.customerStatus,
    filter?.serverCycle,
    cooperInfo,
  ])

  useEffect(() => {
    setFilter(customerInfoExtendFilter(pageState))
    setShouldCallApi(true)
  }, [officeInfo?.value])
  return (
    <>
      <MeterariumPageLayout
        headerDescription={toolTipText.customerInfo.description}
        tooltipText={toolTipText.customerInfo.text}
        hideSearchOptions={accordionOpen}
        setHideSearchOptions={setAccordionOpen}
        filter={filter}
        id={'customer-info'}
        setFilter={setFilter}
        searchCallback={searchHandler}
        total={totalCount}
        control={[
          'device',
          'battery',
          'efos',
          'deviceType',
          'recognizedType',
          'asStatus',
        ]}
        actions={[
          'delete',
          'download',
          ...(outerInstallShowHandler(serverLocalName, officeInfo?.value) ? ['photoDownload'] : []),
          'correct',
          'as',
        ]}
        searchOptions={[
          'customerNumber',
          'customerName',
          'serialNumber',
          'address',
          'managerName',
          'installerName',
          'memo',
        ]}
        checkData={checkData}
        selectedCount={selectionModel.length}
        asValue={{
          asReasonData,
          setAsReasonData,
          setSelectionModel,
          setCheckData,
          // A/S 등록·취소 후 갱신은 현재 페이지를 유지한다
          // (searchCallback은 검색용이라 page를 1로 되돌린다)
          refreshCallback: () => setShouldCallApi(true),
          causeList,
          setOpenCorrectModal,
          openCorrectModal,
        }}
        onDelete={deleteCustomerListCall}
        onCancel={null}
        setTypeName={null}
        onDownloadOpen={() => setDownloadOpen(true)}
        downloadApi={(type: any) => getphotoDownload(type)}
        resetCallbalck={resetHandler}
        newSearchOptions={searchOptionList}
        newSearchField={true}
        newSearchFieldFilter={{diameter: diameterFilter}}
      >
        {/* [CHECKPOINT] 데스크탑 전용 DataGrid — 모바일에서는 CustomerInfoMobileCard로 대체됨
            롤백 시: isMobile 분기 제거 후 이 블록만 남기면 됨 */}
        {isMobile ? (
          <CustomerInfoMobileCard
            rows={rows}
            loading={loading}
            selectionModel={selectionModel}
            cooperInfo={cooperInfo}
            onSelectionChange={(ids: GridRowId[], selectedRows: any[]) => {
              onRowsSelectionHandler(ids, [
                [setCheckData, selectedRows],
                [setSelectionModel, ids],
              ])
            }}
            usePhotoModal={usePhotoModal}
            onPhotoOpen={(row: any) => {
              setTargetRowId(row.id)
              setPhotoData(row)
              openPhotoModal()
            }}
            onImageDetailOpen={(row: any) => {
              setDeviceDetailData(row)
              openImageDetailModal()
            }}
            onCustomerDetailOpen={(row: any) => {
              setCustomerDetailData(row)
              openCustomerDetailModal()
            }}
          />
        ) : (
          <DataGridPro
            rowHeight={180}
            getRowHeight={(params: any) => getRowHeightOnDataGrid(params)}
            apiRef={apiRef}
            headerHeight={30}
            autoHeight={true}
            columnGroupingModel={columnGroupingModel}
            experimentalFeatures={{columnGrouping: true}}
            rows={rows}
            rowCount={rows?.length}
            columns={columns}
            disableColumnMenu
            checkboxSelection
            onSelectionModelChange={(ids, selection) => {
              const selectedRowsData = ids.map((id) => rows.find((row: any) => row.id === id))
              onRowsSelectionHandler(ids, [
                [setCheckData, selectedRowsData],
                [setSelectionModel, ids],
              ])
            }}
            selectionModel={selectionModel}
            loading={loading}
            paginationMode={'server'}
            hideFooterPagination={true}
            pagination={true}
            hideFooter={true}
            sx={{
              '& .MuiDataGrid-cell:focus': {
                outline: 'none',
              },
            }}
          />
        )}

        <CustomPagination filter={filter} setFilter={setFilter} totalCount={totalCount} />
      </MeterariumPageLayout>

      <CorrectModal
        open={openCorrectModal}
        onClose={closeCorrectModal}
        callBack={getCustomerInfo}
      />
      <CustomerTargetImageListModal
        data={deviceDetailData}
        open={imageDetailOpen}
        onClose={closeImageDetailModal}
      />

      <DeviceDetailInfoModal
        data={deviceDetailData}
        open={deviceDetailOpen}
        onClose={closeDeviceDetailModal}
        getList={() => getCustomerInfo()}
      />
      <CustomerDetailInfoMdal
        data={customerDetailData}
        open={customerDetailOpen}
        onClose={closeCustomerDetailModal}
        getList={getCustomerInfo}
      />

      <PhotoModal
        setData={setPhotoData}
        data={photoData}
        open={photoModal}
        onClose={closePhotoModal}
        page='info'
        rowCount={targetRowId}
        filter={filter}
        pagenation={filter.page}
        perPage={filter.rowPerPage}
        getList={getCustomerInfo}
        count={totalCount}
      />

      <ExcelDownLoadModal
        type={'수용가 정보조회'}
        search={filter}
        open={downloadOpen}
        onClose={() => setDownloadOpen(false)}
      />
      <AsBatchOffcanvas toast={toast} />
      <ToastContainer />
    </>
  )
}
export default CustomerInfo
